//CSS
import "./BusinessModel.css";
import "../../Components/Page/Page.css";
import "./BusinessModel.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";

const BusinessModel: React.FC = () => {
  return (
    <div className="quoteSection">
      <SecHeader title="Business Model" />
      <div className="splitContainer">
        <div className="quoteContainer">
          <div className="quoteBackground">
            <text className="quote">
              "We intend to generate outstanding returns for our shareholders by
              selling innovative, exclusive ELF-Tech™ licenses, must have
              E-SPEC™ data and services, CADs, and consulting for positive
              disruption of the $3T/year engines industry."
            </text>
          </div>
        </div>
        <div className="description">
          <p>
            <div>
              <b>Licensing for Engine or Parts Production</b>
              <br />
              Core Revenue will come from production licenses’ ongoing royalties
              <br />
            </div>
            <div>
              <b>Exclusivity and Prototyping Licenses</b>
              <br />
              Allowing manufacturers to test and adjust our parts and assemblies
              to their strengths, and for time or geography exclusivities if
              desired.
              <br />
            </div>
            <div>
              <b>E-SPEC Data and Software</b>
              <br />
              E-SPEC users can explore how ELF-Tech innovations give their
              product the best edge in power, weight, efficiency, emissions and
              costs. This will become the “must use” global gold standard, and
              it will be the only product with all the ELF-Tech design data.
              <br />
            </div>
            <div>
              <b>Engine or Parts CADs</b>
              <br />
              From our library of parts Computer Aided Designs (CAD)s
              <br />
            </div>
            <div>
              <b>Consulting Services​</b>
              <br />
              From our 30-years of R&D, test engines, and assembly knowledge
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessModel;
